module.exports = __webpack_public_path__ + "img/1-1.6c4db3e6.svg";